import React, { useState, useEffect } from "react";
import SkillsDesktop from "../Desktop/SkillsDesktop";
import SkillsMobile from "../Mobile/SkillsMobile";
import { skills } from "../database";
import horizontal from "../images/horizontal.png";

const Skills = () => {
  // console.log(skills);
  const displayDesktopSkills = skills.map((each) => (
    <SkillsDesktop header={each.header} body={each.data} />
  ));

  const displayMobileSkills = skills.map((each) => (
    <SkillsMobile header={each.header} body={each.data} />
  ));

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Adjust the screen size breakpoint as needed
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Set initial screen size

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div>
      {isMobile ? (
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "row ",
              alignItems: "center",
              width: "90%",
              margin: "20% auto 2% auto",
            }}
          >
            <span style={{ color: "#C778DD" }}>#</span>
            <h3 style={{ color: "white", fontWeight: "bolder" }}>Skills</h3>
            <img
              src={horizontal}
              alt=""
              style={{ width: "20%", height: "auto" }}
            />
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "90%",
              margin: "3% auto 2% auto",
            }}
          >
            {displayMobileSkills}
          </div>
        </>
      ) : (
        <>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              width: "90%",
              margin: "10% auto 2% auto",
            }}
          >
            <span style={{ color: "#C778DD" }}>#</span>
            <h3 style={{ color: "white", fontWeight: "bolder" }}>Skills</h3>
            <img src={horizontal} alt="" width="20%" height="auto" />
          </div>

          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "3%",
              justifyContent: "end",
              alignItems: "center",
              width: "90%",
              margin: "3% auto 2% auto",
            }}
          >
            {displayDesktopSkills}
          </div>
        </>
      )}
    </div>
  );
};

export default Skills;
